import { SVGProps } from "react";

const EmptyIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 25, height = 25 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <rect width="120" height="120" x=".5" fill="#FFF0EB" rx="60" />
      <circle
        cx="60.5"
        cy="60"
        r="26.5"
        fill="#FFB878"
        stroke="#E87821"
        strokeWidth="3"
      />
      <path
        fill="#E87821"
        fillRule="evenodd"
        d="M45.5 70.125H68v2.25H45.5v-2.25Zm0-7.5h30v2.25h-30v-2.25Zm0-7.5H68v2.25H45.5v-2.25Zm0-7.5h26.25v2.25H45.5v-2.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default EmptyIcon;
